import React from 'react';

/**
 * Enterprise Brand Emblem: "DA" Dev-Tool Monogram
 * Represents: DevAmit / Distributed Architecture
 * Aesthetic: High-precision cyber ligature with cyan-to-violet gradients
 */
const BrandLogo = ({ 
    size = 24, 
    className = '', 
    withBackground = false,
    ariaLabel = 'DevAmit Systems Brand Monogram'
}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            role="img"
            aria-label={ariaLabel}
        >
            <defs>
                <linearGradient id="da-brand-grad" x1="10%" y1="10%" x2="90%" y2="90%">
                    <stop offset="0%" stopColor="#00F3FF" />
                    <stop offset="45%" stopColor="#3B82F6" />
                    <stop offset="100%" stopColor="#8B5CF6" />
                </linearGradient>
                <filter id="da-brand-glow" x="-20%" y="-20%" width="140%" height="140%">
                    <feDropShadow dx="0" dy="0" stdDeviation="3.5" floodColor="#00F3FF" floodOpacity="0.4" />
                </filter>
            </defs>

            {withBackground && (
                <rect 
                    width="100" 
                    height="100" 
                    rx="22" 
                    fill="#0B0F19" 
                    stroke="rgba(0, 243, 255, 0.28)" 
                    strokeWidth="2"
                />
            )}

            <g filter="url(#da-brand-glow)">
                {/* Outer D Loop (Cyan to Violet Gradient) - Centered X: 18.6 to 81.5, Y: 22.8 to 77.2 */}
                <path
                    d="M 30.5 22.8 H 54.3 C 69.6 22.8 81.5 34.7 81.5 50 C 81.5 65.3 69.6 77.2 54.3 77.2 H 39"
                    stroke="url(#da-brand-grad)"
                    strokeWidth="11"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />

                {/* Left A Stem (Luminous White Contrast Bar) */}
                <path
                    d="M 18.6 77.2 L 44.1 33"
                    stroke="#FFFFFF"
                    strokeWidth="11"
                    strokeLinecap="round"
                />

                {/* Right A Leg (Symmetric baseline at y=77.2) */}
                <path
                    d="M 40.7 43.2 L 58.5 77.2"
                    stroke="url(#da-brand-grad)"
                    strokeWidth="10"
                    strokeLinecap="round"
                />

                {/* Central A Crossbar / Chevron Link */}
                <path
                    d="M 31.3 58.5 H 48.3"
                    stroke="#00F3FF"
                    strokeWidth="6"
                    strokeLinecap="round"
                />
            </g>
        </svg>
    );
};

export default React.memo(BrandLogo);
